import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { catchError, mergeMap, Observable, throwError } from 'rxjs';
import {REQUESTS_BASE_URL} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClubManagmentService {
    private clubData: any = {};
  constructor(
    private http: HttpClient,
  ) {
  }

  updateClubData(data: any) {
    this.clubData = { ...data };
  }

  getClubData() {
    return this.clubData;
  }

  resetClubData() {
    this.clubData = {};
  }

  createClub() {
    return this.http
    .post<any>(
      `${REQUESTS_BASE_URL}/api/club-manager/client-api/v1/club`,
      {
        name: this.clubData.clubName,
        color: this.clubData.clubColor,
        coverPicture: this.clubData.clubCoverPic ? this.clubData.clubCoverPic.name : null,
      })
    .pipe(
      mergeMap((response: any) => {
        const clubId = response.id;
        return this.uploadClubCoverPicture(clubId);
      }),
      catchError((error) => {
        console.error('club creation error:', error);
        return throwError(() => error);
      })
    );
  }

  private uploadClubCoverPicture(clubId: string): Observable<any> {
    const formData = new FormData();
    if (this.clubData.clubCoverPic) {
      formData.append('file', this.clubData.clubCoverPic); 
      formData.append('id', clubId); 
      formData.append('fileCategory', 'CLUB'); 
      formData.append('blobName', this.clubData.clubCoverPic.name); 
    }

    return this.http
      .post(
        `${REQUESTS_BASE_URL}/api/file-manager/client-api/v2/asset/`,
        formData
      ).pipe(
      catchError((error) => {
        console.error('File upload error:', error);
        return throwError(() => error);
      })
    );
  } 

  getAllClubs() {
    return this.http.get<any[]>(`${REQUESTS_BASE_URL}/api/club-manager/client-api/v1/club`);
  }
  
}
